export default {
  state: {
    loading: false
  },
  mutations: {
    triggerLoading(state, status) {
      state.loading = status
    }
  },
  actions: {
    triggerLoading(context, status) {
      context.commit('triggerLoading', status)
    },
  },
  getters: {
    isLoading: state => {
      return state.loading
    }
  }
}